import * as webUtils from '../utils/WebUtils'
import {COOKIE_NAME_RNDINSIDER_BEARERTOKEN} from '../config/commonConstants'
import store from '../store/index'

export function newEventualLog(){
    let token = webUtils.getCookie(COOKIE_NAME_RNDINSIDER_BEARERTOKEN)    
    fetch('http://localhost:8088/caplogs/api/user/me/eventualcaplog',{
        method : 'POST',
        headers : {'Authorization' : token, 'Content-Type' : 'application/json'}
    }).then(
        function(response){
            if(response.ok){
                response.json().then(
                       function(data){
                            store.dispatch('eventualCapLog',data)
                       } 
                )                
            }
        },
        function(reason){
            alert("Reason: " + reason)
        }
    )
}

export function saveNewEventualCapLog(newLogContent){
    let token = webUtils.getCookie(COOKIE_NAME_RNDINSIDER_BEARERTOKEN)    
    fetch('http://localhost:8088/caplogs/api/user/me/caplogs',{
        method : 'POST',
        headers : {'Authorization' : token, 'Content-Type' : 'application/json'},
        body : JSON.stringify({log : newLogContent, friendlyContext : 'caplogs'})
    }).then(
        function(response){
            if(response.ok){
                response.json().then(
                       function(data){
                            store.dispatch('newLogSaved',data)
                       } 
                )                
            }
        },
        function(reason){
            alert("Reason: " + reason)
        }
    )
}

export function capLogsService(newLogContent){
    let token = webUtils.getCookie(COOKIE_NAME_RNDINSIDER_BEARERTOKEN)    
    fetch('http://localhost:8088/caplogs/api/user/me/caplogs',{
        method : 'POST',
        headers : {'Authorization' : token, 'Content-Type' : 'application/json'},
        body : JSON.stringify({log : newLogContent, friendlyContext:'caplogs'})
    }).then(
        function(response){
            if(response.ok){
                response.json().then(
                       function(data){
                            store.dispatch('newLogSaved',data)
                       } 
                )                
            }
        },
        function(reason){
            alert("Reason: " + reason)
        }
    )
}

export function loadCapLogs(){
    let token = webUtils.getCookie(COOKIE_NAME_RNDINSIDER_BEARERTOKEN)
    let payload = {
        method : 'GET',
        headers : {
            "Authorization" : token,
            "ContentType" : "application/json"
        }
    }
    fetch("http://localhost:8088/caplogs/api/user/me/caplogs", payload).then(
        function(response){
            response.json().then(
                function(data){
                    console.log(data);
                    store.state.caplogs = data?data:[]
                }
            )
        },
        function(reason){
            alert(reason)
        }
    )
}

export function updateCapLog(capLogid, updatedCapLogContent){
    //alert(updatedCapLogContent)
    let token = webUtils.getCookie(COOKIE_NAME_RNDINSIDER_BEARERTOKEN)    
    fetch('http://localhost:8088/caplogs/api/user/me/caplogs',{
        method : 'PUT',
        headers : {'Authorization' : token, 'Content-Type' : 'application/json'},
        body : JSON.stringify({id : capLogid, log : updatedCapLogContent})
    }).then(
        function(response){
            if(response.ok){
                response.json().then(
                       function(data){
                            store.dispatch('updatedLogSaved',data)
                       } 
                )                
            }
        },
        function(reason){
            alert("Reason: " + reason)
        }
    )
}
